import { render, staticRenderFns } from "./LegendControl.vue?vue&type=template&id=7861964f&scoped=true&"
import script from "./LegendControl.vue?vue&type=script&lang=js&"
export * from "./LegendControl.vue?vue&type=script&lang=js&"
import style0 from "./LegendControl.vue?vue&type=style&index=0&id=7861964f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7861964f",
  null
  
)

export default component.exports